import { Schema } from 'rsuite'
import { isValidEan } from '@@partner:helpers/product'

export const ProductEansManagerValidationModel = Schema.Model({
  newEan: Schema.Types.StringType().when((schema) => {
    const check = schema.isNonUnique.check()

    return check.hasError
      ? Schema.Types.StringType().addRule(() => false, check.errorMessage)
      : Schema.Types.StringType().addRule(
        (value) => {
          return isValidEan(value)
        },
        'EAN должен содержать 8 или 13 цифр',
        true
      )
  }),
  isNonUnique: Schema.Types.BooleanType().addRule((value, data) => {
    return !value
  }, 'EAN уже добавлен к продукту')
})
